import React, { useEffect, useState } from 'react'
import { FormContext, useForm } from 'react-hook-form'
import { Card, CardActions, CardContent, Grid, TableCell, TableRow } from 'react-md'

import { ConfirmDialog, Cell, PageTitle, ButtonSearch } from 'components/core'
import { DataTable, DeleteButton, EditButton } from 'components/data-table'
import { DataTableResult } from 'components/data-table/types'
import { handleSubmit, Input } from 'components/form'

import { handleSearch, handleEdit, handleDelete } from './actions'
import { defaultValues, validationSchema } from './config'
import { getEquipmentStatusDescription } from 'types/inventory/equipment'

const Component: React.FC = () => {
  const form = useForm({ defaultValues })
  const [filter, setFilter] = useState<any>()
  const [result, setResult] = useState<DataTableResult>({ total: 0, results: [] })
  const [deleteId, setDeleteId] = useState<string>()
  const [toogleUpdate, setToogleUpdate] = useState<boolean>(false)

  useEffect(() => {
    document.title = 'Pesquisa de Equipamento'
  }, [])

  return (
    <>
      <Grid>
        <Cell>
          <PageTitle title='Pesquisa de Equipamento' />
          <Card fullWidth>
            <CardContent>
              <FormContext {...form}>
                <Grid>
                  <Input name='model' label='Modelo' desktopSize={12} tabletSize={8} />
                </Grid>
              </FormContext>
              <CardActions>
                <ButtonSearch onClick={async () => await handleSubmit(form, validationSchema, () => setFilter(form.getValues()))} />
              </CardActions>
            </CardContent>
          </Card>
        </Cell>
        <Cell>
          <DataTable
            filter={filter}
            header={[{ order: 'Model', label: 'Modelo' }, { order: 'EquipmentStatus', label: 'Status' }, { label: '' }]}
            result={result}
            setResult={setResult}
            search={handleSearch}
            update={toogleUpdate}
            total={result ? result.total : 0}>
            {result &&
              result.results &&
              result.results.map((data: any, index) => (
                <TableRow key={index}>
                  <TableCell>{data.model}</TableCell>
                  <TableCell>{getEquipmentStatusDescription(data.equipmentStatus)}</TableCell>
                  <TableCell align='right'>
                    <EditButton id={`edit-${index}`} action={() => handleEdit(data.id)} />
                    <DeleteButton id={`delete-${index}`} action={() => setDeleteId(data.id)} />
                  </TableCell>
                </TableRow>
              ))}
          </DataTable>
        </Cell>
      </Grid>
      <ConfirmDialog
        text='Deseja realmente excluir o equipamento? Essa ação não poderá ser desfeita'
        visible={deleteId ? true : false}
        confirmAction={async () => {
          if (deleteId) if (await handleDelete(deleteId)) setToogleUpdate(!toogleUpdate)
          setDeleteId(undefined)
        }}
        cancelAction={async () => setDeleteId(undefined)}
      />
    </>
  )
}

export default Component
